/**
* Wild Salmon Center
* http://wildsalmoncenter.org
*
* Copyright (c) 2015 Nate Bedortha @ Substance
*/

 ( function( window, undefined ) {
  'use strict';

  document.addEventListener( 'touchstart', function() {}, false);

  /**
   * Picturefill
   */
  picturefill();

  /**
  * Polyfills
  */

  if ( Modernizr ) {

    // Position Sticky
    if ( !Modernizr.csspositionsticky ) {
      var stickyHeader = document.getElementById('masthead');

      Stickyfill.add( stickyHeader );
    }

  }


  /**
   * Search Trigger
   */
   var searchTrigger = document.querySelector( '.search-trigger' ),
   siteHeader = document.querySelector( '.site-header' ),
   searchField = document.querySelector( '.search-field' );

   if ( searchTrigger && siteHeader ) {

     searchTrigger.addEventListener( 'click', function() {

       // @TODO: add aria-expanded to searchTrigger

       siteHeader.classList.toggle( 'show-search' );
       siteHeader.classList.remove( 'show-navigation' );

       if ( searchField === document.activeElement ) {

         //searchField.blur();

       } else {

         //searchField.focus();

       }

     } );


  }

  /**
  * Hamburger Trigger
  */
  var menuToggle = document.querySelector( '.menu-toggle' );

  if ( menuToggle && siteHeader ) {

    menuToggle.addEventListener( 'click', function() {

      if ( menuToggle.hasAttribute( 'aria-expanded' ) ) {

        if ( menuToggle.getAttribute( 'aria-expanded' ) === 'true' ) {

          menuToggle.setAttribute( 'aria-expanded', 'false' );

        } else {
          menuToggle.setAttribute( 'aria-expanded', 'true' );
        }
      }

      siteHeader.classList.toggle( 'show-navigation' );
      siteHeader.classList.remove( 'show-search' );

    } );
  }

  /**
  * Sub Menu Trigger
  */
  var subMenuTriggers = document.querySelectorAll( '.menu-item .sub-menu-icon' );

  for ( var i = 0; i < subMenuTriggers.length; ++i ) {

    //console.log( 'menuItem: ', menuItem );
    //console.log( 'subMenuTrigger[i]: ', subMenuTrigger[i] );
    //console.log( 'subMenuIcon: ', subMenuIcon );

    subMenuTriggers[i].addEventListener( 'click', function( ) {
      var menuItem = this.parentNode,
      openSubMenus = document.querySelectorAll( '.menu-item.show-submenu' );

      menuItem.classList.toggle( 'show-submenu' );

    });

  }

  function removeSubMenu( openSubMenus ) {
    for ( var i = 0; i < openSubMenus.length; ++i ) {
      openSubMenus[i].classList.remove( 'show-submenu' );
    }
  }

  if ( Modernizr.touchevents ) {
    subMenuTriggers = document.querySelectorAll( '.menu-item-depth-0.has-submenu > a' );


    for ( var i = 0; i < subMenuTriggers.length; ++i ) {

      subMenuTriggers[i].addEventListener( 'click', function( e ) {

        if ( window.innerWidth > 1023 ) {
          var menuItem = this.parentNode,
          openSubMenus = document.querySelectorAll( '.menu-item-depth-0.has-submenu.show-submenu' );

          if ( menuItem.classList.contains( 'show-submenu') ) {
            menuItem.classList.remove( 'show-submenu');
          } else {
            e.preventDefault();

            removeSubMenu( openSubMenus );
            menuItem.classList.add( 'show-submenu');
          }
        }
      });
    }
  }

  /**
   * FitVids
   */

   fitvids();


  /**
  * Photo Credits
  *
  var photosWithCredits = document.querySelectorAll( '.singular .entry-content img[data-photo-credit], .hero img[data-photo-credit]' ),
  credits = {};

  for ( var i = 0; i < photosWithCredits.length; ++i ) {
    var creditEl = window.document.createElement( 'span' ),
    credit = photosWithCredits[i].getAttribute( 'data-photo-credit' );

    creditEl.classList.add( 'photo-credit' );
    creditEl.innerHTML = credit;

    photosWithCredits[i].parentNode.insertBefore( creditEl, photosWithCredits[i].nextSibling );

  }


  /**
   * Scroll
   */

   /*
   var stickHeader = function( ) {
     var contentContainer = document.getElementById( 'content' );
     var contentContainerBox = contentContainer.getBoundingClientRect();


     return (
         contentContainerBox.top >= 0 &&
         stickyHeader.classList.contains( 'not-sticky' ) &&
         distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
         distance.right <= (window.innerWidth || document.documentElement.clientWidth)
     );

   };



   window.addEventListener( 'scroll', function() {


       if ( stickHeader() ) {
         console.log( 'in viewport!' );
         stickyHeader.classList.remove( 'not-sticky' );
         stickyHeader.classList.add( 'is-sticky' );
       } else {
         console.log( 'outta viewport!' );
         stickyHeader.classList.remove( 'is-sticky' );
         stickyHeader.classList.add( 'not-sticky' );
       }





   });

   */
  /**
   * Lazy Loading
   */

  /*
  jQuery( '.delayed' ).each( function( ) {

    //console.log( $(this).data( 'delayed-background-image' ) );

    if ( jQuery( this ).is('iframe') ) {

      jQuery(this).attr( 'src', jQuery(this).data( 'src' ) );

    } else {

      jQuery(this).css( 'background-image', 'url(' + jQuery(this).data( 'delayed-background-image' ) + ')' );

    }

  });

*/


 } )( this );
